import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationInfoService } from './notification-info.service';

@Component({
  selector: 'lib-notification-info',
  templateUrl: './notification-info.component.html',
  styleUrls: ['./notification-info.component.scss'],
  standalone: false,
})
export class NotificationInfoComponent implements OnInit {
  showNotificationMessage$: Observable<boolean>;

  constructor(private notificationInfoService: NotificationInfoService) {}

  ngOnInit() {
    this.showNotificationMessage$ =
      this.notificationInfoService.showNotificationMessage();
  }
}
